import { createSlice } from "@reduxjs/toolkit";
import { chartDetails } from "services/student/student";

const initialState = {
    chart : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}

export const chartDetailsSlice = createSlice({
    name: 'chart',
    initialState,
    extraReducers: {
        [chartDetails.pending]: (state) => {
            state.chart.isLoading = true;
        },
        [chartDetails.fulfilled]: (state, { payload }) => {
            state.chart.isLoading = false;
            state.chart.isSuccess = true;
            state.chart.data = payload;
        },
        [chartDetails.rejected]: (state, { payload }) => {
            state.chart.isLoading = false;
            state.chart.isSuccess = false;
            state.chart.errorMessage = payload
        }
    }
})

export default chartDetailsSlice.reducer;